import { render, staticRenderFns } from "./PreOrderLabelList.vue?vue&type=template&id=1120af46&scoped=true&"
import script from "./PreOrderLabelList.vue?vue&type=script&lang=js&"
export * from "./PreOrderLabelList.vue?vue&type=script&lang=js&"
import style0 from "./PreOrderLabelList.vue?vue&type=style&index=0&id=1120af46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1120af46",
  null
  
)

export default component.exports